import { render, staticRenderFns } from "./form20.vue?vue&type=template&id=1b3dd65f&scoped=true"
import script from "./form20.vue?vue&type=script&lang=js"
export * from "./form20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3dd65f",
  null
  
)

export default component.exports